import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const AuthNavigator = () => {
  const history = useHistory();

  useEffect(() => {
    const targetUrl = window.localStorage.getItem("targetUrl");
    const targetUrlSearch = window.localStorage.getItem("targetUrlSearch");
    if (targetUrl) {
      window.localStorage.removeItem("targetUrl");
      if (!targetUrlSearch) {
        history.push(targetUrl);
      } else {
        window.localStorage.removeItem("targetUrlSearch");
        history.push({ pathname: targetUrl, search: targetUrlSearch });
      }
    } else {
      history.push("/");
    }
  }, []);

  return <div />;
};
